import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import reportService from "../../services/reportService";

const handleApiError = (error, thunkAPI, defaultMsg) => {
  const apiError = error?.response?.data;

  let message = defaultMsg;

  if (apiError?.errors) {
    message = Object.values(apiError.errors).flat();
  } else if (apiError?.message) {
    message = apiError.message;
  }

  return thunkAPI.rejectWithValue(Array.isArray(message) ? message : [message]);
};

export const payrollSummaryReport = createAsyncThunk(
  "report/payrollSummaryReport",
  async (params, thunkAPI) => {
    try {
      const response = await reportService.payrollSummaryReport(params);

      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/pdf",
        }),
      );

      window.open(fileURL, "_blank");

      return true;
    } catch (e) {
      return handleApiError(e, thunkAPI, "Payroll summary report failed");
    }
  },
);

export const taxLiabilityReport = createAsyncThunk(
  "report/taxLiabilityReport",
  async (params, thunkAPI) => {
    try {
      const response = await reportService.taxLiabilityReport(params);

      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/pdf",
        }),
      );

      window.open(fileURL, "_blank");

      return true;
    } catch (e) {
      return handleApiError(e, thunkAPI, "Tax liability report failed");
    }
  },
);

const reportSlice = createSlice({
  name: "report",

  initialState: {
    loading: false,
    isSuccess: false,
    errorMessage: null,
  },

  reducers: {
    resetStatus: (state) => {
      state.loading = false;
      state.isSuccess = false;
      state.errorMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // Payroll Summary Report
      .addCase(payrollSummaryReport.pending, (state) => {
        state.loading = true;
        state.isSuccess = false;
        state.errorMessage = null;
      })

      .addCase(payrollSummaryReport.fulfilled, (state) => {
        state.loading = false;
        state.isSuccess = true;
      })

      .addCase(payrollSummaryReport.rejected, (state, action) => {
        state.loading = false;
        state.isSuccess = false;
        state.errorMessage = action.payload;
      })

      // Tax Liability Report
      .addCase(taxLiabilityReport.pending, (state) => {
        state.loading = true;
        state.isSuccess = false;
        state.errorMessage = null;
      })

      .addCase(taxLiabilityReport.fulfilled, (state) => {
        state.loading = false;
        state.isSuccess = true;
      })

      .addCase(taxLiabilityReport.rejected, (state, action) => {
        state.loading = false;
        state.isSuccess = false;
        state.errorMessage = action.payload;
      });
  },
});

export const { resetStatus } = reportSlice.actions;

export default reportSlice.reducer;
